import type { ResolvedMfe } from "@/app/types";
import { routeUnderPrefix } from "./navFilter";

/**
 * Paths the shell serves BEFORE anyone is signed in (P-09; D24 "the click must work with nothing installed"). The one
 * public path today is the link — `/l/<token>`, the URL shape `packages/link`'s `toUrl` makes and the Passport resolves
 * (build plan §4.3, §5.2). A person who opens one has no session and may have no Passport; the module mounted on that
 * path (the passport tenant's `claim`, registered on `/l`) takes them from the preview to a session of their own, and
 * hands it to the shell through `adoptSession` (state/globalState.ts).
 *
 * A public prefix is only public when the tenant actually mounts a non-overlay module under it: the desk, with no
 * module on `/l`, keeps its sign-in screen there like everywhere else.
 */
export const PUBLIC_PATH_PREFIXES: ReadonlyArray<string> = ["/l"];

export type PublicPathModule = Pick<ResolvedMfe, "pathPrefix" | "overlay">;

/** Whether `pathname` is served signed-out: under a public prefix, and under a module the tenant mounts there. */
export function isPublicPath(pathname: string, modules: ReadonlyArray<PublicPathModule>): boolean {
  return PUBLIC_PATH_PREFIXES.some(
    (prefix) =>
      routeUnderPrefix(pathname, prefix) &&
      modules.some((module) => !module.overlay && routeUnderPrefix(module.pathPrefix, prefix) && routeUnderPrefix(pathname, module.pathPrefix)),
  );
}
